import api from "../../domain/api";
import {
  GET_LEADFEEDBACKTYPES,
  ADD_LEADFEEDBACKTYPE,
  EDIT_LEADFEEDBACKTYPE,
  GET_LEADFEEDBACKTYPE,
  RESET_LEADFEEDBACKTYPE,
  GET_ALL_LEADFEEDBACKTYPES,
  ERROR_LEADFEEDBACKTYPE,
} from "../types/leadfeedbacktype_type";
import { handleError } from "../../shared/handleError";
import { setAlert } from "./alert";
export const addLeadfeedbacktype = (formData) => async (dispatch, getState) => {
  try {
    const { data } = await api.post(`/leadfeedbacktypes`, formData);
    dispatch({
      type: ADD_LEADFEEDBACKTYPE,
      payload: data,
    });
  } catch (error) {
    dispatch(handleErrorLocal(error));
    dispatch(handleError(error));
  }
};
export const getLeadfeedbacktypes =
  ({
    termField = "",
    term = "",
    pageNumber = "",
    start_from = "",
    start_to = "",
  }) =>
  async (dispatch) => {
    try {
      dispatch({
        type: RESET_LEADFEEDBACKTYPE,
      });
      const { data } = await api.get(
        `/leadfeedbacktypes?searchTerm=${termField}&keyword=${term}&pageNumber=${pageNumber}&start_from=${start_from}&start_to=${start_to}`
      );

      dispatch({
        type: GET_LEADFEEDBACKTYPES,
        payload: data,
      });
    } catch (error) {
      dispatch(handleErrorLocal(error));
      dispatch(handleError(error));
    }
  };
export const getLeadfeedbacktype = (id) => async (dispatch) => {
  try {
    dispatch({
      type: RESET_LEADFEEDBACKTYPE,
    });
    const { data } = await api.get(`/leadfeedbacktypes/${id}`);

    dispatch({
      type: GET_LEADFEEDBACKTYPE,
      payload: data,
    });
  } catch (error) {
    dispatch(handleErrorLocal(error));
    dispatch(handleError(error));
  }
};
export const editLeadfeedbacktype = (id, formData) => async (dispatch) => {
  try {
    const { data } = await api.put(`/leadfeedbacktypes/${id}`, formData);
    dispatch({
      type: EDIT_LEADFEEDBACKTYPE,
      payload: data,
    });
  } catch (error) {
    dispatch(handleErrorLocal(error));
    dispatch(handleError(error));
  }
};
export const deleteLeadfeedbacktype = (id) => async (dispatch) => {
  try {
    const { data } = await api.delete(`/leadfeedbacktypes/${id}`);
    dispatch(setAlert("Leadfeedbacktype Deleted Successfully", "success"));
  } catch (error) {
    dispatch(handleErrorLocal(error));
    dispatch(handleError(error));
  }
};
export const getAllLeadfeedbacktypes = () => async (dispatch) => {
  try {
    const { data } = await api.get(`/leadfeedbacktypes/all`);

    dispatch({
      type: GET_ALL_LEADFEEDBACKTYPES,
      payload: data,
    });
  } catch (error) {
    dispatch(handleErrorLocal(error));
    dispatch(handleError(error));
  }
};

export const handleErrorLocal = () => async (dispatch) => {
  dispatch({ type: ERROR_LEADFEEDBACKTYPE });
};
